/**
 * Hitowa brand tokens (BC-*), from
 * ConceptDesigns/_templates/_brand-color-design-rule.md.
 *
 * The single source for both portal themes and, in token form, for
 * `styles/rah-shell.scss`. Keep the two in step.
 */
/** BC-* brand tokens. */
export const HITOWA_BRAND = {
  brand: '#0054AC',
  brandHover: '#1487FF',
  brandDeep: '#003267',
  brandDark: '#001F47',
  brandLight: '#E5EDF7',
  brandPale: '#F5FAFF',

  accent: '#EE66A2',
  accentBright: '#FF9AC4',
  accentDeep: '#C2185B',

  canvas: '#F9F8F6',
  surface: '#FFFFFF',
  border: '#DCDFE6',

  inkBody: '#212121',
  inkLabel: '#6E7280',
} as const;
